export default __webpack_public_path__ + "static/media/c-intermediate.ec955746.png";